import axios from 'axios'
import router from '@/router'
import Cookies from 'js-cookie'
import { logout } from '@/utils/api'
import { MessageBox, Message } from 'element-ui'
import {
  getToken,
  removeToken,
  setToken,
  removeCookie,
  getCookie
} from '@/utils/auth'
// import store from '@/store'

// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let requests = []

function getCookie_old (name) {
  var r = document.cookie.match('\\b' + name + '=([^;]*)\\b')
  return r ? r[1] : undefined
}

function setCookie (c_name, value, expire) {
  var date = new Date()
  date.setSeconds(date.getSeconds() + expire)
  document.cookie =
    c_name + '=' + escape(value) + '; expires=' + date.toGMTString()
  //console.log(document.cookie)
}

const instance = axios.create({
  // 公司本地测试环境
  // baseURL: 'http://village1000.d.andoner.cn',
  // 财大测试环境
  // baseURL: 'http://10.2.36.97',
  baseURL: window.location.origin,
  timeout: 25000
})

// 临时方案 不需要token的接口不传token 因为现在后台token过期会401不管需不需要认证
const noTokenApis = [
  '/api/carousel/carousel/',
  '/api/article/article/',
  '/api/area/area/',
  '/api/report/province_interviewee/',
  '/api/report/year_interviewee/',
  '/api/user/system-introduce/'
]

instance.interceptors.request.use(
  config => {
    // 添加token
    if (getToken() && noTokenApis.indexOf(config.url) == -1) {
      config.headers['Authorization'] = 'jwt ' + getToken()
    }
    // if (config.method != 'get') {
    // 	config.headers['X-CSRFToken'] = getCookie_old("csrftoken")
    // }
    if (getCookie_old('csrftoken')) {
      config.headers['X-CSRFToken'] = getCookie_old('csrftoken')
    }

    // 以下为处理同时两种登录传不同的身份
    // if(getCookie_old( 'csrftoken' )){
    // 	// if(config.method!='get'){
    // 		config.headers['X-CSRFToken'] =  getCookie_old("csrftoken")
    // 	// }
    // }else{
    // 	// 添加token
    // 	if (getToken()) {
    // 	  config.headers['Authorization'] = 'jwt '+ getToken()
    // 	}
    // }

    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  async response => {
    const res = response.data
    // if the custom code is not 200, it is judged as an error.
    if (res.code && res.code !== 200) {
      if (res.code === 401) {
        // if (res.code === 401 || res.status == 'error') {
        // 以下是token过期也可以刷新token的方式  我司目前不用这种
        const config = response.config
        // if (!isRefreshing) {
        //   isRefreshing = true
        //   return instance.post('api/jwt/refresh/',{token:getToken()}).then(res => {
        //     const { token } = res.data
        //     localStorage.setItem('token',token)

        //     config.baseURL = ''
        //     // 已经刷新了token，将所有队列中的请求进行重试
        //     requests.forEach(cb => cb())
        //     requests = []
        //     return instance(config)
        //   }).catch(res => {
        //     localStorage.clear()
        //     window.location.hash = '/login'
        //   }).finally(() => {
        //     isRefreshing = false
        //   })
        // } else {
        //   // 正在刷新token，将返回一个未执行resolve的promise
        //   return new Promise((resolve) => {
        //     // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
        //     requests.push(() => {
        //       config.baseURL = ''
        //       resolve(instance(config))
        //     })
        //   })
        // }

        // 正在刷新token，将返回一个未执行resolve的promise
        // new Promise((resolve) => {
        // 	// 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
        // 	requests.push(() => {
        // 		// config.baseURL = ''
        // 		resolve(instance(config))
        // 	})
        // 	console.log(23333);
        // })
        // 防止登录过期后当前页被路缓存后不渲染获取数据了  先不用了 会有个问题取消缓存的这个页面不能再缓存了 目前是在login里面刷新页面
        // router.currentRoute.meta.keepAlive=false
        // await logout()

        if (response.config.url == '/api/user/info/') {
          localStorage.clear()
          removeToken()
          Cookies.remove('csrftoken')
          return Promise.reject(new Error(res.message || 'Error'))
        }

        if (getToken()) {
          localStorage.clear()
          removeToken()
          Cookies.remove('csrftoken')
          window.location.hash = '/login'
        } else {
          window.location.replace(`${window.location.origin}/login-in-school/`)
        }
      } else {
        Message({
          message: res.msg || res.data || res.message || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      // 后台给个token过期时间  设定小于5分钟开始刷新token
      if (getToken() && !isRefreshing) {
        if (
          +new Date(localStorage.getItem('expires')) - +new Date() <
          5 * 60 * 1000
        ) {
          isRefreshing = true
          instance
            .post('api/jwt/refresh/', {
              token: getToken()
            })
            .then(res => {
              const { token, expires } = res
              // localStorage.setItem('token', token)
              localStorage.setItem('expires', expires)
              setToken(token)
            })
            .finally(() => {
              isRefreshing = false
            })
        }
      }
      return response
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.response.data.msg || error.response.data.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default instance
